import React from 'react'
import { useState } from 'react';
import cx from 'classnames'
import { Input } from 'reactstrap';
import styles from './TextCompiler.module.scss'
import Button from '../../components/Button/Button';
function TextCompiler() {
    const [firstDomain,setFistDomain] = useState('')
    const [secondDomain,setSecondDomain] = useState('')
    const [result,setResult] = useState('')
    const [copy,setCopy] = useState(false)
    const handleFilter = ()=>{
        const urls = firstDomain?.replace(/[\r\n]/gm, "")?.replace(" ", "").split(",")
        const domens = secondDomain?.replace(/[\r\n]/gm, "")?.replace(" ", "").split(",")
        const newArr = []
        domens?.forEach(value=> {
            newArr.push(...urls.filter(val=> val.includes(value)))
        })
        setResult(urls.filter(url=>{
            if(!newArr.filter(val=> val.includes(url)).length) return url
        })?.join(',\r\n'))
    }
    const copyText = ()=> {
        navigator.clipboard.writeText(result)
        setCopy(true)
        setTimeout(()=> setCopy(false),2000)
    }
    
  return (
    <div className={styles.container}>
        <div className={styles.domainContainer}>
            <div className={styles.textareaContainer}>
                <p className={styles.fieldLabel}>URL*</p>
                <Input
                    className={cx(styles.textarea)}
                    type="textarea"
                    name="textDescription"
                    placeholder="URL"
                    onChange={(e) => setFistDomain(e.target.value)}
                    value={firstDomain}
                />
            </div>
            <div className={styles.textareaContainer}>
                <p className={styles.fieldLabel}>Domens*</p>
                <Input
                    className={cx(styles.textarea)}
                    type="textarea"
                    name="textDescription"
                    placeholder="Domens"
                    onChange={(e) => setSecondDomain(e.target.value) }
                    value={secondDomain}
                />
                <Button className={styles.filter} onClick={handleFilter}>Filter</Button>
            </div>
        </div>
        <div className={styles.textareaContainerResult}>
            <p className={styles.fieldLabel}>Result</p>
            <Input
                className={cx(styles.textarea)}
                type="textarea"
                name="textDescription"
                placeholder="Result"
                onChange={e=>{}}
                value={result}
            />
            <Button className={styles.copyText} disabled={!result || copy} onClick={copyText}>{copy?<>Copied</>:<>Copy Text</>}</Button>
        </div>
    </div>
  )
}

export default TextCompiler